import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { AppraisalReportFormStore } from '../stores/documentForms/appraisalReportFormStore';

export const useAppraisalReportFormStore = () =>
  useContext<{
    appraisalReportFormStore: AppraisalReportFormStore;
  }>(StoreContext);